/*
 * @Descripttion: 
 * @version: 
 * @Author: 陈宇鹏
 * @Date: 2021-07-19 19:05:15
 * @LastEditors: 陈宇鹏
 * @LastEditTime: 2021-07-22 16:19:31
 */
export default {
    path: "/joinEnterprise",
    name: "joinEnterprise",
    redirect: "/AplayToJoin",
    component: () =>
    import(
      /* webpackChunkName: "joinEnterprise" */ "@/pages/companyEntry/views"
    ),
    meta: {
      title: "绑定"
    },
    children: [
      {
        path: "/AplayToJoin",
        name: "AplayToJoin", 
        component: () =>
          import(
            /* webpackChunkName: "AplayToJoin" */ "@/pages/companyEntry/views/AplayToJoin.vue"
          )
      },
      {
        path: "/companyEntry",
        name: "companyEntry",
        component: () =>
          import(
            /* webpackChunkName: "AplayToJoin" */ "@/pages/companyEntry/views/companyEntry.vue"
          )
      },
      {
        path: "/EnterpriseAuth",
        name: "EnterpriseAuth",
        component: () =>
            import(
                /* webpackChunkName: "EnterpriseAuth" */ "@/pages/companyEntry/views/EnterpriseAuth.vue"
                )
      },
      {
        path: "/AuthorizationInformation",
        name: "AuthorizationInformation",
        component: () =>
            import(
                /* webpackChunkName: "AuthorizationInformation" */ "@/pages/companyEntry/views/AuthorizationInformation.vue"
                )
      },
      {
        path: "/ContractLink",
        name: "ContractLink",
        component: () =>
            import(
                /* webpackChunkName: "ContractLink" */ "@/pages/companyEntry/views/ContractLink.vue"
                )
      },
    ]
  };
  